import { memo } from 'react';
import { HiExternalLink } from 'react-icons/hi';
import { useSelector } from 'react-redux';

const QuickLinks = () => {
  const { usefulLinks } = useSelector((store) => store.user);
  return usefulLinks && usefulLinks.length > 0 ? (
    <div className="bg-white shadow-sm rounded-sm p-4 mb-2 col-span-2 md:col-span-1">
      <div className="text-xl font-bold flex-initial mb-4">
        <span className="text-subHeading font-subHeading">Quick Links</span>
      </div>
      <div className="text-theme">
        {usefulLinks.map((l, index) => (
          // oxlint-disable-next-line react/no-array-index-key
          <a
            href={l.url}
            className="block mb-2"
            target="_blank"
            rel="noreferrer"
            key={`${l.url}-${index}`}
          >
            <HiExternalLink className="inline mr-2" />
            <span className="text-sm">{l.linkText}</span>
          </a>
        ))}
      </div>
    </div>
  ) : (
    ''
  );
};

export default memo(QuickLinks);
